/* eslint-disable no-param-reassign */
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { getSettings } from '../settings';
// const ipServidor = localStorage.getItem('ipservidor');
// const portaServidor = '3023';

const api = axios.create({
  baseURL: getSettings().endPoint,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ptt:Token');
  // eslint-disable-next-line no-param-reassign
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    console.log(window.location.href);
    const token = localStorage.getItem('ptt:Token');
    if (!token) {
      if (window.location.href !== `${window.location.origin}/login` && window.location.href !== `${window.location.origin}/EmailPage` && window.location.href !== `${window.location.origin}/seccionPage`) {
        window.location.href = `${window.location.origin}/login`;
      }
    } else if (err.response && err.response.status === 401) {
      if (window.location.href !== `${window.location.origin}/login` && window.location.href !== `${window.location.origin}/EmailPage` && window.location.href !== `${window.location.origin}/seccionPage`) {
        window.location.href = `${window.location.origin}/seccionPage`;
      }
    }

    return Promise.reject(err);
  },
);

export default api;
